/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Two_Factor_Not_EnabledInputs */

const nl_auth_api_errors_two_factor_not_enabled = /** @type {(inputs: Auth_Api_Errors_Two_Factor_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor authenticatie is niet ingeschakeld`)
};

/**

* @param {Auth_Api_Errors_Two_Factor_Not_EnabledInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_two_factor_not_enabled = /** @type {((inputs?: Auth_Api_Errors_Two_Factor_Not_EnabledInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Two_Factor_Not_EnabledInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_two_factor_not_enabled(inputs)
});
export { auth_api_errors_two_factor_not_enabled as "auth.api_errors.two_factor_not_enabled" }